module.exports = __webpack_public_path__ + "static/media/example-2.a526d533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/CCIWA/example-2.jpg
// module id = 219
// module chunks = 0